export var playerData = {
  0: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  1: [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  2: [0, 1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  3: [0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  4: [0, 1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  5: [0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  6: [0, 1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  7: [0, 1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 14, 15],
  8: [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    23,
    24,
    26,
    30,
    31,
    44,
    45,
    47,
    54,
    61,
    70,
    93,
    95,
    104,
  ],
  9: [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    10,
    11,
    12,
    13,
    14,
    15,
    31,
    104,
    181,
    194,
    273,
    291,
    357,
    358,
    364,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  10: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13, 14, 15],
  11: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15],
  12: [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    14,
    15,
    23,
    24,
    26,
    30,
    31,
    44,
    45,
    47,
    54,
    61,
    70,
    93,
    95,
    104,
  ],
  13: [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    14,
    15,
    23,
    24,
    26,
    30,
    31,
    44,
    45,
    47,
    54,
    61,
    70,
    93,
    95,
    104,
  ],
  14: [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    15,
    20,
    22,
    102,
    179,
    232,
    279,
    294,
    382,
    401,
    405,
    418,
    420,
    421,
    422,
    428,
    432,
    438,
    450,
    452,
  ],
  15: [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    23,
    24,
    26,
    30,
    31,
    44,
    45,
    47,
    54,
    61,
    70,
    93,
    95,
    104,
  ],
  16: [17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
  17: [16, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
  18: [16, 17, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
  19: [16, 17, 18, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
  20: [
    14,
    16,
    17,
    18,
    19,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    102,
    179,
    232,
    279,
    294,
    382,
    401,
    405,
    418,
    420,
    421,
    422,
    428,
    432,
    438,
    450,
    452,
  ],
  21: [
    16,
    17,
    18,
    19,
    20,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    195,
    287,
    371,
    372,
    373,
    374,
    375,
    376,
    377,
    378,
    379,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  22: [
    14,
    16,
    17,
    18,
    19,
    20,
    21,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    102,
    111,
    178,
    179,
    200,
    232,
    279,
    280,
    294,
    333,
    363,
    382,
    383,
    398,
    401,
    405,
    413,
    418,
    420,
    421,
    422,
    423,
    428,
    432,
    438,
    449,
    450,
    452,
    455,
    463,
    469,
    475,
    476,
    484,
    489,
  ],
  23: [
    8,
    12,
    13,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    44,
    45,
    47,
    54,
    61,
    70,
    93,
    95,
    104,
  ],
  24: [
    8,
    12,
    13,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    44,
    45,
    47,
    54,
    61,
    70,
    93,
    95,
    104,
    111,
    143,
    149,
    178,
    180,
    194,
    196,
    230,
    234,
    235,
    257,
    262,
    273,
    276,
    280,
    299,
  ],
  25: [16, 17, 18, 19, 20, 21, 22, 23, 24, 26, 27, 28, 29, 30, 31],
  26: [
    8,
    12,
    13,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    27,
    28,
    29,
    30,
    31,
    44,
    45,
    47,
    54,
    61,
    70,
    93,
    95,
    104,
    111,
    165,
    196,
    201,
    273,
    352,
    370,
    385,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    535,
    555,
  ],
  27: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 28, 29, 30, 31],
  28: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 29, 30, 31],
  29: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 30, 31],
  30: [
    8,
    12,
    13,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    31,
    44,
    45,
    47,
    54,
    61,
    70,
    93,
    95,
    104,
    111,
    143,
    149,
    178,
    180,
    194,
    196,
    230,
    234,
    235,
    257,
    262,
    273,
    276,
    280,
    299,
  ],
  31: [
    8,
    9,
    12,
    13,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    44,
    45,
    47,
    54,
    61,
    70,
    93,
    95,
    104,
    181,
    194,
    273,
    291,
    357,
    358,
    364,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  32: [33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47],
  33: [32, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47],
  34: [32, 33, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47],
  35: [32, 33, 34, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47],
  36: [32, 33, 34, 35, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47],
  37: [32, 33, 34, 35, 36, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47],
  38: [32, 33, 34, 35, 36, 37, 39, 40, 41, 42, 43, 44, 45, 46, 47],
  39: [32, 33, 34, 35, 36, 37, 38, 40, 41, 42, 43, 44, 45, 46, 47],
  40: [32, 33, 34, 35, 36, 37, 38, 39, 41, 42, 43, 44, 45, 46, 47],
  41: [32, 33, 34, 35, 36, 37, 38, 39, 40, 42, 43, 44, 45, 46, 47],
  42: [32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 43, 44, 45, 46, 47],
  43: [32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 44, 45, 46, 47],
  44: [
    8,
    12,
    13,
    15,
    23,
    24,
    26,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    45,
    46,
    47,
    54,
    61,
    70,
    93,
    95,
    104,
  ],
  45: [
    8,
    12,
    13,
    15,
    23,
    24,
    26,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    46,
    47,
    54,
    61,
    70,
    93,
    95,
    104,
  ],
  46: [32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 47],
  47: [
    8,
    12,
    13,
    15,
    23,
    24,
    26,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    54,
    61,
    70,
    93,
    95,
    104,
    111,
    165,
    196,
    201,
    273,
    352,
    370,
    385,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    535,
    555,
  ],
  48: [49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63],
  49: [48, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63],
  50: [48, 49, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63],
  51: [48, 49, 50, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63],
  52: [48, 49, 50, 51, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63],
  53: [48, 49, 50, 51, 52, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63],
  54: [
    8,
    12,
    13,
    15,
    23,
    24,
    26,
    30,
    31,
    44,
    45,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    70,
    93,
    95,
    104,
    111,
    143,
    149,
    165,
    178,
    180,
    194,
    196,
    201,
    230,
    234,
    235,
    257,
    262,
    273,
    276,
    280,
    299,
    321,
    322,
    323,
    324,
    325,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
    352,
    370,
    385,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    535,
    555,
  ],
  55: [48, 49, 50, 51, 52, 53, 54, 56, 57, 58, 59, 60, 61, 62, 63],
  56: [48, 49, 50, 51, 52, 53, 54, 55, 57, 58, 59, 60, 61, 62, 63],
  57: [48, 49, 50, 51, 52, 53, 54, 55, 56, 58, 59, 60, 61, 62, 63],
  58: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 59, 60, 61, 62, 63],
  59: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 61, 62, 63],
  60: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 61, 62, 63],
  61: [
    8,
    12,
    13,
    15,
    23,
    24,
    26,
    30,
    31,
    44,
    45,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    62,
    63,
    70,
    93,
    95,
    104,
  ],
  62: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 63],
  63: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62],
  64: [65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
  65: [64, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
  66: [64, 65, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
  67: [64, 65, 66, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
  68: [64, 65, 66, 67, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
  69: [64, 65, 66, 67, 68, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
  70: [
    8,
    12,
    13,
    15,
    23,
    24,
    26,
    30,
    31,
    44,
    45,
    47,
    54,
    61,
    64,
    65,
    66,
    67,
    68,
    69,
    71,
    72,
    73,
    74,
    75,
    76,
    77,
    78,
    79,
    93,
    95,
    104,
  ],
  71: [64, 65, 66, 67, 68, 69, 70, 72, 73, 74, 75, 76, 77, 78, 79],
  72: [64, 65, 66, 67, 68, 69, 70, 71, 73, 74, 75, 76, 77, 78, 79],
  73: [64, 65, 66, 67, 68, 69, 70, 71, 72, 74, 75, 76, 77, 78, 79],
  74: [64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 75, 76, 77, 78, 79],
  75: [64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 76, 77, 78, 79],
  76: [64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 77, 78, 79],
  77: [64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 78, 79],
  78: [64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 79],
  79: [64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78],
  80: [81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95],
  81: [80, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95],
  82: [80, 81, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95],
  83: [80, 81, 82, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95],
  84: [80, 81, 82, 83, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95],
  85: [80, 81, 82, 83, 84, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95],
  86: [80, 81, 82, 83, 84, 85, 87, 88, 89, 90, 91, 92, 93, 94, 95],
  87: [80, 81, 82, 83, 84, 85, 86, 88, 89, 90, 91, 92, 93, 94, 95],
  88: [80, 81, 82, 83, 84, 85, 86, 87, 89, 90, 91, 92, 93, 94, 95],
  89: [80, 81, 82, 83, 84, 85, 86, 87, 88, 90, 91, 92, 93, 94, 95],
  90: [80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 92, 93, 94, 95],
  91: [80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 92, 93, 94, 95],
  92: [80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 93, 94, 95],
  93: [
    8,
    12,
    13,
    15,
    23,
    24,
    26,
    30,
    31,
    44,
    45,
    47,
    54,
    61,
    70,
    80,
    81,
    82,
    83,
    84,
    85,
    86,
    87,
    88,
    89,
    90,
    91,
    92,
    94,
    95,
    104,
  ],
  94: [80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 95],
  95: [
    8,
    12,
    13,
    15,
    23,
    24,
    26,
    30,
    31,
    44,
    45,
    47,
    54,
    61,
    70,
    80,
    81,
    82,
    83,
    84,
    85,
    86,
    87,
    88,
    89,
    90,
    91,
    92,
    93,
    94,
    104,
  ],
  96: [97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111],
  97: [96, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111],
  98: [96, 97, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111],
  99: [96, 97, 98, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111],
  100: [96, 97, 98, 99, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111],
  101: [96, 97, 98, 99, 100, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111],
  102: [
    14,
    20,
    22,
    96,
    97,
    98,
    99,
    100,
    101,
    103,
    104,
    105,
    106,
    107,
    108,
    109,
    110,
    111,
    179,
    232,
    279,
    294,
    382,
    401,
    405,
    418,
    420,
    421,
    422,
    428,
    432,
    438,
    450,
    452,
  ],
  103: [96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111],
  104: [
    8,
    9,
    12,
    13,
    15,
    23,
    24,
    26,
    30,
    31,
    44,
    45,
    47,
    54,
    61,
    70,
    93,
    95,
    96,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    105,
    106,
    107,
    108,
    109,
    110,
    111,
    143,
    149,
    178,
    180,
    181,
    194,
    196,
    230,
    234,
    235,
    257,
    262,
    273,
    276,
    280,
    291,
    299,
    357,
    358,
    364,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  105: [96, 97, 98, 99, 100, 101, 102, 103, 104, 106, 107, 108, 109, 110, 111],
  106: [96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 107, 108, 109, 110, 111],
  107: [96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 110, 111],
  108: [96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 109, 110, 111],
  109: [
    96,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    106,
    107,
    108,
    110,
    111,
    124,
    126,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
  ],
  110: [96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 111],
  111: [
    22,
    24,
    26,
    30,
    47,
    54,
    96,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    106,
    107,
    108,
    109,
    110,
    143,
    149,
    165,
    178,
    180,
    194,
    196,
    200,
    201,
    230,
    234,
    235,
    257,
    262,
    273,
    276,
    280,
    299,
    333,
    352,
    363,
    370,
    383,
    385,
    398,
    405,
    413,
    423,
    432,
    441,
    449,
    455,
    463,
    469,
    475,
    476,
    477,
    484,
    489,
    497,
    515,
    535,
    555,
  ],
  112: [
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  113: [
    112,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  114: [
    112,
    113,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  115: [
    112,
    113,
    114,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  116: [
    112,
    113,
    114,
    115,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  117: [
    112,
    113,
    114,
    115,
    116,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  118: [
    112,
    113,
    114,
    115,
    116,
    117,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  119: [
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  120: [
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  121: [
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  122: [
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  123: [
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    124,
    125,
    126,
    127,
    128,
    129,
  ],
  124: [
    109,
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    125,
    126,
    127,
    128,
    129,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
  ],
  125: [
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    126,
    127,
    128,
    129,
  ],
  126: [
    109,
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    127,
    128,
    129,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
  ],
  127: [
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    128,
    129,
  ],
  128: [
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    129,
  ],
  129: [
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
  ],
  130: [
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  131: [
    130,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  132: [
    130,
    131,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  133: [
    130,
    131,
    132,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  134: [
    130,
    131,
    132,
    133,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  135: [
    130,
    131,
    132,
    133,
    134,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  136: [
    130,
    131,
    132,
    133,
    134,
    135,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  137: [
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  138: [
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  139: [
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  140: [
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
  ],
  141: [
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  142: [
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
  ],
  143: [
    24,
    30,
    54,
    104,
    111,
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    178,
    180,
    194,
    196,
    230,
    234,
    235,
    257,
    262,
    273,
    276,
    280,
    299,
  ],
  144: [
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    145,
    146,
    147,
    148,
    149,
  ],
  145: [
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    146,
    147,
    148,
    149,
  ],
  146: [
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    147,
    148,
    149,
  ],
  147: [
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    148,
    149,
  ],
  148: [
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    149,
  ],
  149: [
    24,
    30,
    54,
    104,
    111,
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    178,
    180,
    194,
    196,
    230,
    234,
    235,
    257,
    262,
    273,
    276,
    280,
    299,
  ],
  150: [
    140,
    143,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
  ],
  151: [
    140,
    143,
    150,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
  ],
  152: [
    140,
    143,
    150,
    151,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
  ],
  153: [
    140,
    143,
    150,
    151,
    152,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
  ],
  154: [
    140,
    143,
    150,
    151,
    152,
    153,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
  ],
  155: [
    140,
    143,
    150,
    151,
    152,
    153,
    154,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
  ],
  156: [
    140,
    143,
    150,
    151,
    152,
    153,
    154,
    155,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
  ],
  157: [
    140,
    143,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
  ],
  158: [
    140,
    143,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
  ],
  159: [
    140,
    143,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    160,
    161,
    162,
    163,
    164,
    165,
  ],
  160: [
    140,
    143,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    161,
    162,
    163,
    164,
    165,
  ],
  161: [
    140,
    143,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    162,
    163,
    164,
    165,
  ],
  162: [
    140,
    143,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    163,
    164,
    165,
  ],
  163: [
    140,
    143,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    164,
    165,
  ],
  164: [
    140,
    143,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    165,
  ],
  165: [
    26,
    47,
    54,
    111,
    140,
    143,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    196,
    201,
    273,
    352,
    370,
    385,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    535,
    555,
  ],
  166: [
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
  ],
  167: [
    166,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
  ],
  168: [
    166,
    167,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
  ],
  169: [
    166,
    167,
    168,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
  ],
  170: [
    166,
    167,
    168,
    169,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
  ],
  171: [
    166,
    167,
    168,
    169,
    170,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
  ],
  172: [
    166,
    167,
    168,
    169,
    170,
    171,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
  ],
  173: [
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
  ],
  174: [
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
  ],
  175: [
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    176,
    177,
    178,
    179,
    180,
    181,
  ],
  176: [
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    177,
    178,
    179,
    180,
    181,
  ],
  177: [
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    178,
    179,
    180,
    181,
  ],
  178: [
    22,
    24,
    30,
    54,
    104,
    109,
    111,
    124,
    126,
    143,
    149,
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    179,
    180,
    181,
    194,
    195,
    196,
    200,
    217,
    230,
    234,
    235,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    257,
    262,
    273,
    276,
    280,
    299,
    333,
    363,
    383,
    398,
    405,
    413,
    423,
    449,
    455,
    463,
    469,
    475,
    476,
    484,
    489,
  ],
  179: [
    14,
    20,
    22,
    102,
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    180,
    181,
    232,
    279,
    294,
    382,
    401,
    405,
    418,
    420,
    421,
    422,
    428,
    432,
    438,
    450,
    452,
  ],
  180: [
    24,
    30,
    54,
    104,
    111,
    143,
    149,
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    181,
    194,
    196,
    230,
    234,
    235,
    257,
    262,
    273,
    276,
    280,
    299,
  ],
  181: [
    9,
    31,
    104,
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    194,
    273,
    291,
    357,
    358,
    364,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  182: [
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  183: [
    182,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  184: [
    182,
    183,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  185: [
    182,
    183,
    184,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  186: [
    182,
    183,
    184,
    185,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  187: [
    182,
    183,
    184,
    185,
    186,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  188: [
    182,
    183,
    184,
    185,
    186,
    187,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  189: [
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  190: [
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  191: [
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  192: [
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  193: [
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
  ],
  194: [
    9,
    24,
    30,
    31,
    54,
    104,
    111,
    143,
    149,
    178,
    180,
    181,
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    230,
    234,
    235,
    257,
    262,
    273,
    276,
    280,
    291,
    299,
    357,
    358,
    364,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  195: [
    21,
    109,
    124,
    126,
    178,
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    196,
    197,
    198,
    199,
    200,
    201,
    217,
    230,
    234,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    287,
    371,
    372,
    373,
    374,
    375,
    376,
    377,
    378,
    379,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  196: [
    24,
    26,
    30,
    47,
    54,
    104,
    109,
    111,
    124,
    126,
    143,
    149,
    165,
    178,
    180,
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    197,
    198,
    199,
    200,
    201,
    217,
    230,
    234,
    235,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    257,
    262,
    273,
    276,
    280,
    299,
    352,
    370,
    385,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    535,
    555,
  ],
  197: [
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    198,
    199,
    200,
    201,
  ],
  198: [
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    199,
    200,
    201,
  ],
  199: [
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    200,
    201,
  ],
  200: [
    22,
    109,
    111,
    124,
    126,
    178,
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    201,
    217,
    230,
    234,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    276,
    280,
    333,
    337,
    338,
    339,
    340,
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
    363,
    383,
    398,
    405,
    413,
    423,
    449,
    455,
    463,
    469,
    475,
    476,
    484,
    489,
  ],
  201: [
    26,
    47,
    54,
    111,
    165,
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    273,
    352,
    370,
    385,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    535,
    555,
  ],
  202: [
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  203: [
    202,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  204: [
    202,
    203,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  205: [
    202,
    203,
    204,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  206: [
    202,
    203,
    204,
    205,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  207: [
    202,
    203,
    204,
    205,
    206,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  208: [
    202,
    203,
    204,
    205,
    206,
    207,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  209: [
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  210: [
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  211: [
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  212: [
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  213: [
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  214: [
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    215,
    216,
    217,
    218,
    219,
    220,
  ],
  215: [
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    216,
    217,
    218,
    219,
    220,
  ],
  216: [
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    217,
    218,
    219,
    220,
  ],
  217: [
    109,
    124,
    126,
    178,
    195,
    196,
    200,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    218,
    219,
    220,
    230,
    234,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
  ],
  218: [
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    219,
    220,
  ],
  219: [
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    220,
  ],
  220: [
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
  ],
  221: [
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
  ],
  222: [
    221,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
  ],
  223: [
    221,
    222,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
  ],
  224: [
    221,
    222,
    223,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
  ],
  225: [
    221,
    222,
    223,
    224,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
  ],
  226: [
    221,
    222,
    223,
    224,
    225,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
  ],
  227: [
    221,
    222,
    223,
    224,
    225,
    226,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
  ],
  228: [
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
  ],
  229: [
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
  ],
  230: [
    24,
    30,
    54,
    104,
    109,
    111,
    124,
    126,
    143,
    149,
    178,
    180,
    194,
    195,
    196,
    200,
    217,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    231,
    232,
    233,
    234,
    235,
    236,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    257,
    262,
    273,
    276,
    280,
    299,
  ],
  231: [
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    232,
    233,
    234,
    235,
    236,
  ],
  232: [
    14,
    20,
    22,
    102,
    179,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    233,
    234,
    235,
    236,
    279,
    294,
    382,
    401,
    405,
    418,
    420,
    421,
    422,
    428,
    432,
    438,
    450,
    452,
  ],
  233: [
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    234,
    235,
    236,
  ],
  234: [
    24,
    30,
    54,
    104,
    109,
    111,
    124,
    126,
    143,
    149,
    178,
    180,
    194,
    195,
    196,
    200,
    217,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    235,
    236,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    257,
    262,
    273,
    276,
    280,
    299,
  ],
  235: [
    24,
    30,
    54,
    104,
    111,
    143,
    149,
    178,
    180,
    194,
    196,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    236,
    257,
    262,
    273,
    276,
    280,
    299,
  ],
  236: [
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
  ],
  237: [
    109,
    124,
    126,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
  ],
  238: [
    109,
    124,
    126,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
  ],
  239: [
    109,
    124,
    126,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    238,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
  ],
  240: [
    109,
    124,
    126,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    238,
    239,
    241,
    242,
    243,
    244,
    245,
    246,
  ],
  241: [
    109,
    124,
    126,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    238,
    239,
    240,
    242,
    243,
    244,
    245,
    246,
  ],
  242: [
    109,
    124,
    126,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    238,
    239,
    240,
    241,
    243,
    244,
    245,
    246,
  ],
  243: [
    109,
    124,
    126,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    238,
    239,
    240,
    241,
    242,
    244,
    245,
    246,
  ],
  244: [
    109,
    124,
    126,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    245,
    246,
  ],
  245: [
    109,
    124,
    126,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    246,
    258,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  246: [
    109,
    124,
    126,
    178,
    195,
    196,
    200,
    217,
    230,
    234,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
  ],
  247: [
    248,
    249,
    250,
    251,
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    263,
    264,
  ],
  248: [
    247,
    249,
    250,
    251,
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    263,
    264,
  ],
  249: [
    247,
    248,
    250,
    251,
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    263,
    264,
  ],
  250: [
    247,
    248,
    249,
    251,
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    263,
    264,
  ],
  251: [
    247,
    248,
    249,
    250,
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    263,
    264,
  ],
  252: [
    247,
    248,
    249,
    250,
    251,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    263,
    264,
  ],
  253: [
    247,
    248,
    249,
    250,
    251,
    252,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    263,
    264,
  ],
  254: [
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    263,
    264,
  ],
  255: [
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    254,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    263,
    264,
  ],
  256: [
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    254,
    255,
    257,
    258,
    259,
    260,
    261,
    262,
    263,
    264,
  ],
  257: [
    24,
    30,
    54,
    104,
    111,
    143,
    149,
    178,
    180,
    194,
    196,
    230,
    234,
    235,
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    254,
    255,
    256,
    258,
    259,
    260,
    261,
    262,
    263,
    264,
    273,
    276,
    280,
    299,
  ],
  258: [
    245,
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    254,
    255,
    256,
    257,
    259,
    260,
    261,
    262,
    263,
    264,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  259: [
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    260,
    261,
    262,
    263,
    264,
  ],
  260: [
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    261,
    262,
    263,
    264,
  ],
  261: [
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    262,
    263,
    264,
  ],
  262: [
    24,
    30,
    54,
    104,
    111,
    143,
    149,
    178,
    180,
    194,
    196,
    230,
    234,
    235,
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    263,
    264,
    273,
    276,
    280,
    299,
  ],
  263: [
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    264,
  ],
  264: [
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    254,
    255,
    256,
    257,
    258,
    259,
    260,
    261,
    262,
    263,
  ],
  265: [
    266,
    267,
    268,
    269,
    270,
    271,
    272,
    273,
    274,
    275,
    276,
    277,
    278,
    279,
    280,
  ],
  266: [
    265,
    267,
    268,
    269,
    270,
    271,
    272,
    273,
    274,
    275,
    276,
    277,
    278,
    279,
    280,
  ],
  267: [
    265,
    266,
    268,
    269,
    270,
    271,
    272,
    273,
    274,
    275,
    276,
    277,
    278,
    279,
    280,
  ],
  268: [
    265,
    266,
    267,
    269,
    270,
    271,
    272,
    273,
    274,
    275,
    276,
    277,
    278,
    279,
    280,
  ],
  269: [
    265,
    266,
    267,
    268,
    270,
    271,
    272,
    273,
    274,
    275,
    276,
    277,
    278,
    279,
    280,
  ],
  270: [
    265,
    266,
    267,
    268,
    269,
    271,
    272,
    273,
    274,
    275,
    276,
    277,
    278,
    279,
    280,
  ],
  271: [
    265,
    266,
    267,
    268,
    269,
    270,
    272,
    273,
    274,
    275,
    276,
    277,
    278,
    279,
    280,
  ],
  272: [
    265,
    266,
    267,
    268,
    269,
    270,
    271,
    273,
    274,
    275,
    276,
    277,
    278,
    279,
    280,
  ],
  273: [
    9,
    24,
    26,
    30,
    31,
    47,
    54,
    104,
    111,
    143,
    149,
    165,
    178,
    180,
    181,
    194,
    196,
    201,
    230,
    234,
    235,
    257,
    262,
    265,
    266,
    267,
    268,
    269,
    270,
    271,
    272,
    274,
    275,
    276,
    277,
    278,
    279,
    280,
    291,
    299,
    352,
    357,
    358,
    364,
    370,
    385,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    535,
    555,
  ],
  274: [
    265,
    266,
    267,
    268,
    269,
    270,
    271,
    272,
    273,
    275,
    276,
    277,
    278,
    279,
    280,
  ],
  275: [
    265,
    266,
    267,
    268,
    269,
    270,
    271,
    272,
    273,
    274,
    276,
    277,
    278,
    279,
    280,
  ],
  276: [
    24,
    30,
    54,
    104,
    111,
    143,
    149,
    178,
    180,
    194,
    196,
    200,
    230,
    234,
    235,
    257,
    262,
    265,
    266,
    267,
    268,
    269,
    270,
    271,
    272,
    273,
    274,
    275,
    277,
    278,
    279,
    280,
    299,
    337,
    338,
    339,
    340,
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
  ],
  277: [
    265,
    266,
    267,
    268,
    269,
    270,
    271,
    272,
    273,
    274,
    275,
    276,
    278,
    279,
    280,
  ],
  278: [
    265,
    266,
    267,
    268,
    269,
    270,
    271,
    272,
    273,
    274,
    275,
    276,
    277,
    279,
    280,
  ],
  279: [
    14,
    20,
    22,
    102,
    179,
    232,
    265,
    266,
    267,
    268,
    269,
    270,
    271,
    272,
    273,
    274,
    275,
    276,
    277,
    278,
    280,
    294,
    382,
    401,
    405,
    418,
    420,
    421,
    422,
    428,
    432,
    438,
    450,
    452,
  ],
  280: [
    22,
    24,
    30,
    54,
    104,
    111,
    143,
    149,
    178,
    180,
    194,
    196,
    200,
    230,
    234,
    235,
    257,
    262,
    265,
    266,
    267,
    268,
    269,
    270,
    271,
    272,
    273,
    274,
    275,
    276,
    277,
    278,
    279,
    299,
    333,
    363,
    383,
    398,
    405,
    413,
    423,
    449,
    455,
    463,
    469,
    475,
    476,
    484,
    489,
  ],
  281: [
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
  ],
  282: [
    281,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
  ],
  283: [
    281,
    282,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
  ],
  284: [
    281,
    282,
    283,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
  ],
  285: [
    281,
    282,
    283,
    284,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
  ],
  286: [
    281,
    282,
    283,
    284,
    285,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
  ],
  287: [
    21,
    195,
    281,
    282,
    283,
    284,
    285,
    286,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
    371,
    372,
    373,
    374,
    375,
    376,
    377,
    378,
    379,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  288: [
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
  ],
  289: [
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
  ],
  290: [
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
  ],
  291: [
    9,
    31,
    104,
    181,
    194,
    273,
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
    357,
    358,
    364,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  292: [
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
  ],
  293: [
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    294,
    295,
    296,
    297,
    298,
    299,
    300,
  ],
  294: [
    14,
    20,
    22,
    102,
    179,
    232,
    279,
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    295,
    296,
    297,
    298,
    299,
    300,
    382,
    401,
    405,
    418,
    420,
    421,
    422,
    428,
    432,
    438,
    450,
    452,
  ],
  295: [
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    296,
    297,
    298,
    299,
    300,
  ],
  296: [
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    297,
    298,
    299,
    300,
  ],
  297: [
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    298,
    299,
    300,
  ],
  298: [
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    299,
    300,
  ],
  299: [
    24,
    30,
    54,
    104,
    111,
    143,
    149,
    178,
    180,
    194,
    196,
    230,
    234,
    235,
    257,
    262,
    273,
    276,
    280,
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    300,
    321,
    322,
    323,
    324,
    325,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
  ],
  300: [
    281,
    282,
    283,
    284,
    285,
    286,
    287,
    288,
    289,
    290,
    291,
    292,
    293,
    294,
    295,
    296,
    297,
    298,
    299,
  ],
  301: [
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  302: [
    301,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  303: [
    301,
    302,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  304: [
    301,
    302,
    303,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  305: [
    301,
    302,
    303,
    304,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  306: [
    301,
    302,
    303,
    304,
    305,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  307: [
    301,
    302,
    303,
    304,
    305,
    306,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  308: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  309: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  310: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  311: [
    245,
    258,
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  312: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  313: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  314: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    315,
    316,
    317,
    318,
    319,
    320,
  ],
  315: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    316,
    317,
    318,
    319,
    320,
  ],
  316: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    317,
    318,
    319,
    320,
  ],
  317: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    318,
    319,
    320,
  ],
  318: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    319,
    320,
  ],
  319: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    320,
  ],
  320: [
    301,
    302,
    303,
    304,
    305,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
  ],
  321: [
    54,
    245,
    258,
    299,
    311,
    322,
    323,
    324,
    325,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  322: [
    54,
    299,
    321,
    323,
    324,
    325,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
  ],
  323: [
    54,
    299,
    321,
    322,
    324,
    325,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
  ],
  324: [
    54,
    299,
    321,
    322,
    323,
    325,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
  ],
  325: [
    54,
    299,
    321,
    322,
    323,
    324,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
  ],
  326: [
    54,
    299,
    321,
    322,
    323,
    324,
    325,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
  ],
  327: [
    54,
    299,
    321,
    322,
    323,
    324,
    325,
    326,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
  ],
  328: [
    54,
    299,
    321,
    322,
    323,
    324,
    325,
    326,
    327,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
  ],
  329: [
    54,
    299,
    321,
    322,
    323,
    324,
    325,
    326,
    327,
    328,
    330,
    331,
    332,
    333,
    334,
    335,
    336,
  ],
  330: [
    54,
    299,
    321,
    322,
    323,
    324,
    325,
    326,
    327,
    328,
    329,
    331,
    332,
    333,
    334,
    335,
    336,
  ],
  331: [
    54,
    299,
    321,
    322,
    323,
    324,
    325,
    326,
    327,
    328,
    329,
    330,
    332,
    333,
    334,
    335,
    336,
  ],
  332: [
    54,
    299,
    321,
    322,
    323,
    324,
    325,
    326,
    327,
    328,
    329,
    330,
    331,
    333,
    334,
    335,
    336,
  ],
  333: [
    22,
    54,
    111,
    178,
    200,
    245,
    258,
    280,
    299,
    311,
    321,
    322,
    323,
    324,
    325,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    334,
    335,
    336,
    345,
    347,
    349,
    363,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
    398,
    405,
    413,
    423,
    449,
    455,
    463,
    469,
    475,
    476,
    484,
    489,
  ],
  334: [
    54,
    299,
    321,
    322,
    323,
    324,
    325,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    335,
    336,
  ],
  335: [
    54,
    299,
    321,
    322,
    323,
    324,
    325,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    336,
  ],
  336: [
    54,
    245,
    258,
    299,
    311,
    321,
    322,
    323,
    324,
    325,
    326,
    327,
    328,
    329,
    330,
    331,
    332,
    333,
    334,
    335,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  337: [
    200,
    276,
    338,
    339,
    340,
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
  ],
  338: [
    200,
    276,
    337,
    339,
    340,
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
  ],
  339: [
    200,
    276,
    337,
    338,
    340,
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
  ],
  340: [
    200,
    276,
    337,
    338,
    339,
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
  ],
  341: [
    200,
    276,
    337,
    338,
    339,
    340,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
  ],
  342: [
    200,
    276,
    337,
    338,
    339,
    340,
    341,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
  ],
  343: [
    200,
    276,
    337,
    338,
    339,
    340,
    341,
    342,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
  ],
  344: [
    200,
    276,
    337,
    338,
    339,
    340,
    341,
    342,
    343,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
  ],
  345: [
    200,
    245,
    258,
    276,
    311,
    321,
    333,
    336,
    337,
    338,
    339,
    340,
    341,
    342,
    343,
    344,
    346,
    347,
    348,
    349,
    350,
    351,
    352,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  346: [
    200,
    276,
    337,
    338,
    339,
    340,
    341,
    342,
    343,
    344,
    345,
    347,
    348,
    349,
    350,
    351,
    352,
  ],
  347: [
    200,
    245,
    258,
    276,
    311,
    321,
    333,
    336,
    337,
    338,
    339,
    340,
    341,
    342,
    343,
    344,
    345,
    346,
    348,
    349,
    350,
    351,
    352,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  348: [
    200,
    276,
    337,
    338,
    339,
    340,
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    349,
    350,
    351,
    352,
  ],
  349: [
    200,
    245,
    258,
    276,
    311,
    321,
    333,
    336,
    337,
    338,
    339,
    340,
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    350,
    351,
    352,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  350: [
    200,
    276,
    337,
    338,
    339,
    340,
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    351,
    352,
  ],
  351: [
    200,
    276,
    337,
    338,
    339,
    340,
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    352,
  ],
  352: [
    26,
    47,
    54,
    111,
    165,
    196,
    200,
    201,
    273,
    276,
    337,
    338,
    339,
    340,
    341,
    342,
    343,
    344,
    345,
    346,
    347,
    348,
    349,
    350,
    351,
    370,
    385,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    535,
    555,
  ],
  353: [
    354,
    355,
    356,
    357,
    358,
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    369,
    370,
  ],
  354: [
    353,
    355,
    356,
    357,
    358,
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    369,
    370,
  ],
  355: [
    353,
    354,
    356,
    357,
    358,
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    369,
    370,
  ],
  356: [
    353,
    354,
    355,
    357,
    358,
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    369,
    370,
  ],
  357: [
    9,
    31,
    104,
    181,
    194,
    273,
    291,
    353,
    354,
    355,
    356,
    358,
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    369,
    370,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  358: [
    9,
    31,
    104,
    181,
    194,
    273,
    291,
    353,
    354,
    355,
    356,
    357,
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    369,
    370,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  359: [
    353,
    354,
    355,
    356,
    357,
    358,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    369,
    370,
  ],
  360: [
    353,
    354,
    355,
    356,
    357,
    358,
    359,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    369,
    370,
  ],
  361: [
    353,
    354,
    355,
    356,
    357,
    358,
    359,
    360,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    369,
    370,
  ],
  362: [
    353,
    354,
    355,
    356,
    357,
    358,
    359,
    360,
    361,
    363,
    364,
    365,
    366,
    367,
    368,
    369,
    370,
  ],
  363: [
    22,
    111,
    178,
    200,
    280,
    333,
    353,
    354,
    355,
    356,
    357,
    358,
    359,
    360,
    361,
    362,
    364,
    365,
    366,
    367,
    368,
    369,
    370,
    383,
    398,
    405,
    413,
    423,
    449,
    455,
    463,
    469,
    475,
    476,
    484,
    489,
  ],
  364: [
    9,
    31,
    104,
    181,
    194,
    273,
    291,
    353,
    354,
    355,
    356,
    357,
    358,
    359,
    360,
    361,
    362,
    363,
    365,
    366,
    367,
    368,
    369,
    370,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  365: [
    353,
    354,
    355,
    356,
    357,
    358,
    359,
    360,
    361,
    362,
    363,
    364,
    366,
    367,
    368,
    369,
    370,
  ],
  366: [
    353,
    354,
    355,
    356,
    357,
    358,
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    367,
    368,
    369,
    370,
  ],
  367: [
    353,
    354,
    355,
    356,
    357,
    358,
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    368,
    369,
    370,
  ],
  368: [
    353,
    354,
    355,
    356,
    357,
    358,
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    369,
    370,
  ],
  369: [
    353,
    354,
    355,
    356,
    357,
    358,
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    370,
  ],
  370: [
    26,
    47,
    54,
    111,
    165,
    196,
    201,
    273,
    352,
    353,
    354,
    355,
    356,
    357,
    358,
    359,
    360,
    361,
    362,
    363,
    364,
    365,
    366,
    367,
    368,
    369,
    385,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    535,
    555,
  ],
  371: [
    21,
    195,
    287,
    372,
    373,
    374,
    375,
    376,
    377,
    378,
    379,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  372: [
    21,
    195,
    287,
    371,
    373,
    374,
    375,
    376,
    377,
    378,
    379,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  373: [
    21,
    195,
    287,
    371,
    372,
    374,
    375,
    376,
    377,
    378,
    379,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  374: [
    21,
    195,
    287,
    371,
    372,
    373,
    375,
    376,
    377,
    378,
    379,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  375: [
    21,
    195,
    287,
    371,
    372,
    373,
    374,
    376,
    377,
    378,
    379,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  376: [
    21,
    195,
    287,
    371,
    372,
    373,
    374,
    375,
    377,
    378,
    379,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  377: [
    21,
    195,
    287,
    371,
    372,
    373,
    374,
    375,
    376,
    378,
    379,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  378: [
    21,
    195,
    287,
    371,
    372,
    373,
    374,
    375,
    376,
    377,
    379,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  379: [
    21,
    195,
    287,
    371,
    372,
    373,
    374,
    375,
    376,
    377,
    378,
    380,
    381,
    382,
    383,
    384,
    385,
  ],
  380: [
    21,
    195,
    287,
    371,
    372,
    373,
    374,
    375,
    376,
    377,
    378,
    379,
    381,
    382,
    383,
    384,
    385,
  ],
  381: [
    21,
    195,
    287,
    371,
    372,
    373,
    374,
    375,
    376,
    377,
    378,
    379,
    380,
    382,
    383,
    384,
    385,
  ],
  382: [
    14,
    20,
    21,
    22,
    102,
    179,
    195,
    232,
    279,
    287,
    294,
    371,
    372,
    373,
    374,
    375,
    376,
    377,
    378,
    379,
    380,
    381,
    383,
    384,
    385,
    401,
    405,
    418,
    420,
    421,
    422,
    428,
    432,
    438,
    450,
    452,
  ],
  383: [
    21,
    22,
    111,
    178,
    195,
    200,
    245,
    258,
    280,
    287,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    363,
    371,
    372,
    373,
    374,
    375,
    376,
    377,
    378,
    379,
    380,
    381,
    382,
    384,
    385,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
    398,
    405,
    413,
    423,
    449,
    455,
    463,
    469,
    475,
    476,
    484,
    489,
  ],
  384: [
    21,
    195,
    287,
    371,
    372,
    373,
    374,
    375,
    376,
    377,
    378,
    379,
    380,
    381,
    382,
    383,
    385,
  ],
  385: [
    21,
    26,
    47,
    54,
    111,
    165,
    195,
    196,
    201,
    273,
    287,
    352,
    370,
    371,
    372,
    373,
    374,
    375,
    376,
    377,
    378,
    379,
    380,
    381,
    382,
    383,
    384,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    535,
    555,
  ],
  386: [
    245,
    258,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  387: [
    245,
    258,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  388: [
    245,
    258,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    389,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  389: [
    245,
    258,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    390,
    391,
    392,
    393,
    394,
    395,
  ],
  390: [
    245,
    258,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    389,
    391,
    392,
    393,
    394,
    395,
  ],
  391: [
    245,
    258,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    389,
    390,
    392,
    393,
    394,
    395,
  ],
  392: [
    245,
    258,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    393,
    394,
    395,
  ],
  393: [
    245,
    258,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    394,
    395,
  ],
  394: [
    245,
    258,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    395,
  ],
  395: [
    245,
    258,
    311,
    321,
    333,
    336,
    345,
    347,
    349,
    383,
    386,
    387,
    388,
    389,
    390,
    391,
    392,
    393,
    394,
  ],
  396: [
    9,
    31,
    104,
    181,
    194,
    273,
    291,
    357,
    358,
    364,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  397: [
    9,
    31,
    104,
    181,
    194,
    273,
    291,
    357,
    358,
    364,
    396,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  398: [
    9,
    22,
    31,
    104,
    111,
    178,
    181,
    194,
    200,
    273,
    280,
    291,
    333,
    357,
    358,
    363,
    364,
    383,
    396,
    397,
    399,
    400,
    401,
    402,
    403,
    404,
    405,
    413,
    423,
    449,
    455,
    463,
    469,
    475,
    476,
    484,
    489,
  ],
  399: [
    9,
    31,
    104,
    181,
    194,
    273,
    291,
    357,
    358,
    364,
    396,
    397,
    398,
    400,
    401,
    402,
    403,
    404,
    405,
  ],
  400: [
    9,
    31,
    104,
    181,
    194,
    273,
    291,
    357,
    358,
    364,
    396,
    397,
    398,
    399,
    401,
    402,
    403,
    404,
    405,
  ],
  401: [
    9,
    14,
    20,
    22,
    31,
    102,
    104,
    179,
    181,
    194,
    232,
    273,
    279,
    291,
    294,
    357,
    358,
    364,
    382,
    396,
    397,
    398,
    399,
    400,
    402,
    403,
    404,
    405,
    418,
    420,
    421,
    422,
    428,
    432,
    438,
    450,
    452,
  ],
  402: [
    9,
    31,
    104,
    181,
    194,
    273,
    291,
    357,
    358,
    364,
    396,
    397,
    398,
    399,
    400,
    401,
    403,
    404,
    405,
  ],
  403: [
    9,
    31,
    104,
    181,
    194,
    273,
    291,
    357,
    358,
    364,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    404,
    405,
  ],
  404: [
    9,
    31,
    104,
    181,
    194,
    273,
    291,
    357,
    358,
    364,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    405,
  ],
  405: [
    9,
    14,
    20,
    22,
    31,
    102,
    104,
    111,
    178,
    179,
    181,
    194,
    200,
    232,
    273,
    279,
    280,
    291,
    294,
    333,
    357,
    358,
    363,
    364,
    382,
    383,
    396,
    397,
    398,
    399,
    400,
    401,
    402,
    403,
    404,
    413,
    418,
    420,
    421,
    422,
    423,
    428,
    432,
    438,
    449,
    450,
    452,
    455,
    463,
    469,
    475,
    476,
    484,
    489,
  ],
  406: [
    407,
    408,
    409,
    410,
    411,
    412,
    413,
    414,
    415,
    416,
    417,
    418,
    419,
    420,
    421,
    422,
    423,
  ],
  407: [
    406,
    408,
    409,
    410,
    411,
    412,
    413,
    414,
    415,
    416,
    417,
    418,
    419,
    420,
    421,
    422,
    423,
  ],
  408: [
    406,
    407,
    409,
    410,
    411,
    412,
    413,
    414,
    415,
    416,
    417,
    418,
    419,
    420,
    421,
    422,
    423,
  ],
  409: [
    406,
    407,
    408,
    410,
    411,
    412,
    413,
    414,
    415,
    416,
    417,
    418,
    419,
    420,
    421,
    422,
    423,
  ],
  410: [
    406,
    407,
    408,
    409,
    411,
    412,
    413,
    414,
    415,
    416,
    417,
    418,
    419,
    420,
    421,
    422,
    423,
  ],
  411: [
    406,
    407,
    408,
    409,
    410,
    412,
    413,
    414,
    415,
    416,
    417,
    418,
    419,
    420,
    421,
    422,
    423,
  ],
  412: [
    406,
    407,
    408,
    409,
    410,
    411,
    413,
    414,
    415,
    416,
    417,
    418,
    419,
    420,
    421,
    422,
    423,
  ],
  413: [
    22,
    26,
    47,
    54,
    111,
    165,
    178,
    196,
    200,
    201,
    273,
    280,
    333,
    352,
    363,
    370,
    383,
    385,
    398,
    405,
    406,
    407,
    408,
    409,
    410,
    411,
    412,
    414,
    415,
    416,
    417,
    418,
    419,
    420,
    421,
    422,
    423,
    432,
    441,
    449,
    455,
    463,
    469,
    475,
    476,
    477,
    484,
    489,
    497,
    515,
    535,
    555,
  ],
  414: [
    406,
    407,
    408,
    409,
    410,
    411,
    412,
    413,
    415,
    416,
    417,
    418,
    419,
    420,
    421,
    422,
    423,
  ],
  415: [
    406,
    407,
    408,
    409,
    410,
    411,
    412,
    413,
    414,
    416,
    417,
    418,
    419,
    420,
    421,
    422,
    423,
  ],
  416: [
    406,
    407,
    408,
    409,
    410,
    411,
    412,
    413,
    414,
    415,
    417,
    418,
    419,
    420,
    421,
    422,
    423,
  ],
  417: [
    406,
    407,
    408,
    409,
    410,
    411,
    412,
    413,
    414,
    415,
    416,
    418,
    419,
    420,
    421,
    422,
    423,
  ],
  418: [
    14,
    20,
    22,
    102,
    179,
    232,
    279,
    294,
    382,
    401,
    405,
    406,
    407,
    408,
    409,
    410,
    411,
    412,
    413,
    414,
    415,
    416,
    417,
    419,
    420,
    421,
    422,
    423,
    428,
    432,
    438,
    450,
    452,
  ],
  419: [
    406,
    407,
    408,
    409,
    410,
    411,
    412,
    413,
    414,
    415,
    416,
    417,
    418,
    420,
    421,
    422,
    423,
  ],
  420: [
    14,
    20,
    22,
    102,
    179,
    232,
    279,
    294,
    382,
    401,
    405,
    406,
    407,
    408,
    409,
    410,
    411,
    412,
    413,
    414,
    415,
    416,
    417,
    418,
    419,
    421,
    422,
    423,
    428,
    432,
    438,
    450,
    452,
  ],
  421: [
    14,
    20,
    22,
    102,
    179,
    232,
    279,
    294,
    382,
    401,
    405,
    406,
    407,
    408,
    409,
    410,
    411,
    412,
    413,
    414,
    415,
    416,
    417,
    418,
    419,
    420,
    422,
    423,
    428,
    432,
    438,
    450,
    452,
  ],
  422: [
    14,
    20,
    22,
    102,
    179,
    232,
    279,
    294,
    382,
    401,
    405,
    406,
    407,
    408,
    409,
    410,
    411,
    412,
    413,
    414,
    415,
    416,
    417,
    418,
    419,
    420,
    421,
    423,
    428,
    432,
    438,
    450,
    452,
  ],
  423: [
    22,
    26,
    47,
    54,
    111,
    165,
    178,
    196,
    200,
    201,
    273,
    280,
    333,
    352,
    363,
    370,
    383,
    385,
    398,
    405,
    406,
    407,
    408,
    409,
    410,
    411,
    412,
    413,
    414,
    415,
    416,
    417,
    418,
    419,
    420,
    421,
    422,
    432,
    441,
    449,
    455,
    463,
    469,
    475,
    476,
    477,
    484,
    489,
    497,
    515,
    535,
    555,
  ],
  424: [
    425,
    426,
    427,
    428,
    429,
    430,
    431,
    432,
    433,
    434,
    435,
    436,
    437,
    438,
    439,
    440,
    441,
  ],
  425: [
    424,
    426,
    427,
    428,
    429,
    430,
    431,
    432,
    433,
    434,
    435,
    436,
    437,
    438,
    439,
    440,
    441,
  ],
  426: [
    424,
    425,
    427,
    428,
    429,
    430,
    431,
    432,
    433,
    434,
    435,
    436,
    437,
    438,
    439,
    440,
    441,
  ],
  427: [
    424,
    425,
    426,
    428,
    429,
    430,
    431,
    432,
    433,
    434,
    435,
    436,
    437,
    438,
    439,
    440,
    441,
  ],
  428: [
    14,
    20,
    22,
    102,
    179,
    232,
    279,
    294,
    382,
    401,
    405,
    418,
    420,
    421,
    422,
    424,
    425,
    426,
    427,
    429,
    430,
    431,
    432,
    433,
    434,
    435,
    436,
    437,
    438,
    439,
    440,
    441,
    450,
    452,
    476,
    494,
    556,
    557,
    558,
    559,
    560,
    561,
    562,
    563,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  429: [
    424,
    425,
    426,
    427,
    428,
    430,
    431,
    432,
    433,
    434,
    435,
    436,
    437,
    438,
    439,
    440,
    441,
  ],
  430: [
    424,
    425,
    426,
    427,
    428,
    429,
    431,
    432,
    433,
    434,
    435,
    436,
    437,
    438,
    439,
    440,
    441,
  ],
  431: [
    424,
    425,
    426,
    427,
    428,
    429,
    430,
    432,
    433,
    434,
    435,
    436,
    437,
    438,
    439,
    440,
    441,
  ],
  432: [
    14,
    20,
    22,
    26,
    47,
    54,
    102,
    111,
    165,
    179,
    196,
    201,
    232,
    273,
    279,
    294,
    352,
    370,
    382,
    385,
    401,
    405,
    413,
    418,
    420,
    421,
    422,
    423,
    424,
    425,
    426,
    427,
    428,
    429,
    430,
    431,
    433,
    434,
    435,
    436,
    437,
    438,
    439,
    440,
    441,
    450,
    452,
    477,
    497,
    515,
    535,
    555,
  ],
  433: [
    424,
    425,
    426,
    427,
    428,
    429,
    430,
    431,
    432,
    434,
    435,
    436,
    437,
    438,
    439,
    440,
    441,
  ],
  434: [
    424,
    425,
    426,
    427,
    428,
    429,
    430,
    431,
    432,
    433,
    435,
    436,
    437,
    438,
    439,
    440,
    441,
  ],
  435: [
    424,
    425,
    426,
    427,
    428,
    429,
    430,
    431,
    432,
    433,
    434,
    436,
    437,
    438,
    439,
    440,
    441,
  ],
  436: [
    424,
    425,
    426,
    427,
    428,
    429,
    430,
    431,
    432,
    433,
    434,
    435,
    437,
    438,
    439,
    440,
    441,
  ],
  437: [
    424,
    425,
    426,
    427,
    428,
    429,
    430,
    431,
    432,
    433,
    434,
    435,
    436,
    438,
    439,
    440,
    441,
  ],
  438: [
    14,
    20,
    22,
    102,
    179,
    232,
    279,
    294,
    382,
    401,
    405,
    418,
    420,
    421,
    422,
    424,
    425,
    426,
    427,
    428,
    429,
    430,
    431,
    432,
    433,
    434,
    435,
    436,
    437,
    439,
    440,
    441,
    450,
    452,
  ],
  439: [
    424,
    425,
    426,
    427,
    428,
    429,
    430,
    431,
    432,
    433,
    434,
    435,
    436,
    437,
    438,
    440,
    441,
  ],
  440: [
    424,
    425,
    426,
    427,
    428,
    429,
    430,
    431,
    432,
    433,
    434,
    435,
    436,
    437,
    438,
    439,
    441,
  ],
  441: [
    26,
    47,
    54,
    111,
    165,
    196,
    201,
    273,
    352,
    370,
    385,
    413,
    423,
    424,
    425,
    426,
    427,
    428,
    429,
    430,
    431,
    432,
    433,
    434,
    435,
    436,
    437,
    438,
    439,
    440,
    477,
    497,
    515,
    535,
    555,
  ],
  442: [
    443,
    444,
    445,
    446,
    447,
    448,
    449,
    450,
    451,
    452,
    453,
    454,
    455,
    456,
    457,
    458,
    459,
  ],
  443: [
    442,
    444,
    445,
    446,
    447,
    448,
    449,
    450,
    451,
    452,
    453,
    454,
    455,
    456,
    457,
    458,
    459,
  ],
  444: [
    442,
    443,
    445,
    446,
    447,
    448,
    449,
    450,
    451,
    452,
    453,
    454,
    455,
    456,
    457,
    458,
    459,
  ],
  445: [
    442,
    443,
    444,
    446,
    447,
    448,
    449,
    450,
    451,
    452,
    453,
    454,
    455,
    456,
    457,
    458,
    459,
  ],
  446: [
    442,
    443,
    444,
    445,
    447,
    448,
    449,
    450,
    451,
    452,
    453,
    454,
    455,
    456,
    457,
    458,
    459,
  ],
  447: [
    442,
    443,
    444,
    445,
    446,
    448,
    449,
    450,
    451,
    452,
    453,
    454,
    455,
    456,
    457,
    458,
    459,
  ],
  448: [
    442,
    443,
    444,
    445,
    446,
    447,
    449,
    450,
    451,
    452,
    453,
    454,
    455,
    456,
    457,
    458,
    459,
  ],
  449: [
    22,
    111,
    178,
    200,
    280,
    333,
    363,
    383,
    398,
    405,
    413,
    423,
    442,
    443,
    444,
    445,
    446,
    447,
    448,
    450,
    451,
    452,
    453,
    454,
    455,
    456,
    457,
    458,
    459,
    463,
    469,
    475,
    476,
    484,
    489,
  ],
  450: [
    14,
    20,
    22,
    102,
    179,
    232,
    279,
    294,
    382,
    401,
    405,
    418,
    420,
    421,
    422,
    428,
    432,
    438,
    442,
    443,
    444,
    445,
    446,
    447,
    448,
    449,
    451,
    452,
    453,
    454,
    455,
    456,
    457,
    458,
    459,
    476,
    494,
    556,
    557,
    558,
    559,
    560,
    561,
    562,
    563,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  451: [
    442,
    443,
    444,
    445,
    446,
    447,
    448,
    449,
    450,
    452,
    453,
    454,
    455,
    456,
    457,
    458,
    459,
  ],
  452: [
    14,
    20,
    22,
    102,
    179,
    232,
    279,
    294,
    382,
    401,
    405,
    418,
    420,
    421,
    422,
    428,
    432,
    438,
    442,
    443,
    444,
    445,
    446,
    447,
    448,
    449,
    450,
    451,
    453,
    454,
    455,
    456,
    457,
    458,
    459,
  ],
  453: [
    442,
    443,
    444,
    445,
    446,
    447,
    448,
    449,
    450,
    451,
    452,
    454,
    455,
    456,
    457,
    458,
    459,
  ],
  454: [
    442,
    443,
    444,
    445,
    446,
    447,
    448,
    449,
    450,
    451,
    452,
    453,
    455,
    456,
    457,
    458,
    459,
  ],
  455: [
    22,
    111,
    178,
    200,
    280,
    333,
    363,
    383,
    398,
    405,
    413,
    423,
    442,
    443,
    444,
    445,
    446,
    447,
    448,
    449,
    450,
    451,
    452,
    453,
    454,
    456,
    457,
    458,
    459,
    463,
    469,
    475,
    476,
    484,
    489,
  ],
  456: [
    442,
    443,
    444,
    445,
    446,
    447,
    448,
    449,
    450,
    451,
    452,
    453,
    454,
    455,
    457,
    458,
    459,
  ],
  457: [
    442,
    443,
    444,
    445,
    446,
    447,
    448,
    449,
    450,
    451,
    452,
    453,
    454,
    455,
    456,
    458,
    459,
  ],
  458: [
    442,
    443,
    444,
    445,
    446,
    447,
    448,
    449,
    450,
    451,
    452,
    453,
    454,
    455,
    456,
    457,
    459,
  ],
  459: [
    442,
    443,
    444,
    445,
    446,
    447,
    448,
    449,
    450,
    451,
    452,
    453,
    454,
    455,
    456,
    457,
    458,
  ],
  460: [
    461,
    462,
    463,
    464,
    465,
    466,
    467,
    468,
    469,
    470,
    471,
    472,
    473,
    474,
    475,
    476,
    477,
  ],
  461: [
    460,
    462,
    463,
    464,
    465,
    466,
    467,
    468,
    469,
    470,
    471,
    472,
    473,
    474,
    475,
    476,
    477,
  ],
  462: [
    460,
    461,
    463,
    464,
    465,
    466,
    467,
    468,
    469,
    470,
    471,
    472,
    473,
    474,
    475,
    476,
    477,
  ],
  463: [
    22,
    111,
    178,
    200,
    280,
    333,
    363,
    383,
    398,
    405,
    413,
    423,
    449,
    455,
    460,
    461,
    462,
    464,
    465,
    466,
    467,
    468,
    469,
    470,
    471,
    472,
    473,
    474,
    475,
    476,
    477,
    484,
    489,
  ],
  464: [
    460,
    461,
    462,
    463,
    465,
    466,
    467,
    468,
    469,
    470,
    471,
    472,
    473,
    474,
    475,
    476,
    477,
  ],
  465: [
    460,
    461,
    462,
    463,
    464,
    466,
    467,
    468,
    469,
    470,
    471,
    472,
    473,
    474,
    475,
    476,
    477,
  ],
  466: [
    460,
    461,
    462,
    463,
    464,
    465,
    467,
    468,
    469,
    470,
    471,
    472,
    473,
    474,
    475,
    476,
    477,
  ],
  467: [
    460,
    461,
    462,
    463,
    464,
    465,
    466,
    468,
    469,
    470,
    471,
    472,
    473,
    474,
    475,
    476,
    477,
  ],
  468: [
    460,
    461,
    462,
    463,
    464,
    465,
    466,
    467,
    469,
    470,
    471,
    472,
    473,
    474,
    475,
    476,
    477,
  ],
  469: [
    22,
    111,
    178,
    200,
    280,
    333,
    363,
    383,
    398,
    405,
    413,
    423,
    449,
    455,
    460,
    461,
    462,
    463,
    464,
    465,
    466,
    467,
    468,
    470,
    471,
    472,
    473,
    474,
    475,
    476,
    477,
    484,
    489,
  ],
  470: [
    460,
    461,
    462,
    463,
    464,
    465,
    466,
    467,
    468,
    469,
    471,
    472,
    473,
    474,
    475,
    476,
    477,
  ],
  471: [
    460,
    461,
    462,
    463,
    464,
    465,
    466,
    467,
    468,
    469,
    470,
    472,
    473,
    474,
    475,
    476,
    477,
  ],
  472: [
    460,
    461,
    462,
    463,
    464,
    465,
    466,
    467,
    468,
    469,
    470,
    471,
    473,
    474,
    475,
    476,
    477,
  ],
  473: [
    460,
    461,
    462,
    463,
    464,
    465,
    466,
    467,
    468,
    469,
    470,
    471,
    472,
    474,
    475,
    476,
    477,
  ],
  474: [
    460,
    461,
    462,
    463,
    464,
    465,
    466,
    467,
    468,
    469,
    470,
    471,
    472,
    473,
    475,
    476,
    477,
  ],
  475: [
    22,
    111,
    178,
    200,
    280,
    333,
    363,
    383,
    398,
    405,
    413,
    423,
    449,
    455,
    460,
    461,
    462,
    463,
    464,
    465,
    466,
    467,
    468,
    469,
    470,
    471,
    472,
    473,
    474,
    476,
    477,
    484,
    489,
  ],
  476: [
    22,
    111,
    178,
    200,
    280,
    333,
    363,
    383,
    398,
    405,
    413,
    423,
    428,
    449,
    450,
    455,
    460,
    461,
    462,
    463,
    464,
    465,
    466,
    467,
    468,
    469,
    470,
    471,
    472,
    473,
    474,
    475,
    477,
    484,
    489,
    494,
    556,
    557,
    558,
    559,
    560,
    561,
    562,
    563,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  477: [
    26,
    47,
    54,
    111,
    165,
    196,
    201,
    273,
    352,
    370,
    385,
    413,
    423,
    432,
    441,
    460,
    461,
    462,
    463,
    464,
    465,
    466,
    467,
    468,
    469,
    470,
    471,
    472,
    473,
    474,
    475,
    476,
    497,
    515,
    535,
    555,
  ],
  478: [
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  479: [
    478,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  480: [
    478,
    479,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  481: [
    478,
    479,
    480,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  482: [
    478,
    479,
    480,
    481,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  483: [
    478,
    479,
    480,
    481,
    482,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  484: [
    22,
    111,
    178,
    200,
    280,
    333,
    363,
    383,
    398,
    405,
    413,
    423,
    449,
    455,
    463,
    469,
    475,
    476,
    478,
    479,
    480,
    481,
    482,
    483,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  485: [
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  486: [
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  487: [
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  488: [
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  489: [
    22,
    111,
    178,
    200,
    280,
    333,
    363,
    383,
    398,
    405,
    413,
    423,
    449,
    455,
    463,
    469,
    475,
    476,
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  490: [
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    491,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  491: [
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    492,
    493,
    494,
    495,
    496,
    497,
  ],
  492: [
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    493,
    494,
    495,
    496,
    497,
  ],
  493: [
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    494,
    495,
    496,
    497,
  ],
  494: [
    428,
    450,
    476,
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    495,
    496,
    497,
    556,
    557,
    558,
    559,
    560,
    561,
    562,
    563,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  495: [
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    496,
    497,
  ],
  496: [
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    497,
  ],
  497: [
    26,
    47,
    54,
    111,
    165,
    196,
    201,
    273,
    352,
    370,
    385,
    413,
    423,
    432,
    441,
    477,
    478,
    479,
    480,
    481,
    482,
    483,
    484,
    485,
    486,
    487,
    488,
    489,
    490,
    491,
    492,
    493,
    494,
    495,
    496,
    515,
    535,
    555,
  ],
  498: [
    499,
    500,
    501,
    502,
    503,
    504,
    505,
    506,
    507,
    508,
    509,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  499: [
    498,
    500,
    501,
    502,
    503,
    504,
    505,
    506,
    507,
    508,
    509,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  500: [
    498,
    499,
    501,
    502,
    503,
    504,
    505,
    506,
    507,
    508,
    509,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  501: [
    498,
    499,
    500,
    502,
    503,
    504,
    505,
    506,
    507,
    508,
    509,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  502: [
    498,
    499,
    500,
    501,
    503,
    504,
    505,
    506,
    507,
    508,
    509,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  503: [
    498,
    499,
    500,
    501,
    502,
    504,
    505,
    506,
    507,
    508,
    509,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  504: [
    498,
    499,
    500,
    501,
    502,
    503,
    505,
    506,
    507,
    508,
    509,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  505: [
    498,
    499,
    500,
    501,
    502,
    503,
    504,
    506,
    507,
    508,
    509,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  506: [
    498,
    499,
    500,
    501,
    502,
    503,
    504,
    505,
    507,
    508,
    509,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  507: [
    498,
    499,
    500,
    501,
    502,
    503,
    504,
    505,
    506,
    508,
    509,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  508: [
    498,
    499,
    500,
    501,
    502,
    503,
    504,
    505,
    506,
    507,
    509,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  509: [
    498,
    499,
    500,
    501,
    502,
    503,
    504,
    505,
    506,
    507,
    508,
    510,
    511,
    512,
    513,
    514,
    515,
  ],
  510: [
    498,
    499,
    500,
    501,
    502,
    503,
    504,
    505,
    506,
    507,
    508,
    509,
    511,
    512,
    513,
    514,
    515,
  ],
  511: [
    498,
    499,
    500,
    501,
    502,
    503,
    504,
    505,
    506,
    507,
    508,
    509,
    510,
    512,
    513,
    514,
    515,
  ],
  512: [
    498,
    499,
    500,
    501,
    502,
    503,
    504,
    505,
    506,
    507,
    508,
    509,
    510,
    511,
    513,
    514,
    515,
  ],
  513: [
    498,
    499,
    500,
    501,
    502,
    503,
    504,
    505,
    506,
    507,
    508,
    509,
    510,
    511,
    512,
    514,
    515,
  ],
  514: [
    498,
    499,
    500,
    501,
    502,
    503,
    504,
    505,
    506,
    507,
    508,
    509,
    510,
    511,
    512,
    513,
    515,
  ],
  515: [
    26,
    47,
    54,
    111,
    165,
    196,
    201,
    273,
    352,
    370,
    385,
    413,
    423,
    432,
    441,
    477,
    497,
    498,
    499,
    500,
    501,
    502,
    503,
    504,
    505,
    506,
    507,
    508,
    509,
    510,
    511,
    512,
    513,
    514,
    535,
    555,
  ],
  516: [
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  517: [
    516,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  518: [
    516,
    517,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  519: [
    516,
    517,
    518,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  520: [
    516,
    517,
    518,
    519,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  521: [
    516,
    517,
    518,
    519,
    520,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  522: [
    516,
    517,
    518,
    519,
    520,
    521,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  523: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  524: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  525: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  526: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  527: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  528: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    529,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  529: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    530,
    531,
    532,
    533,
    534,
    535,
  ],
  530: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    531,
    532,
    533,
    534,
    535,
  ],
  531: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    532,
    533,
    534,
    535,
  ],
  532: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    533,
    534,
    535,
  ],
  533: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    534,
    535,
  ],
  534: [
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    535,
  ],
  535: [
    26,
    47,
    54,
    111,
    165,
    196,
    201,
    273,
    352,
    370,
    385,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    516,
    517,
    518,
    519,
    520,
    521,
    522,
    523,
    524,
    525,
    526,
    527,
    528,
    529,
    530,
    531,
    532,
    533,
    534,
    555,
  ],
  536: [
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  537: [
    536,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  538: [
    536,
    537,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  539: [
    536,
    537,
    538,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  540: [
    536,
    537,
    538,
    539,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  541: [
    536,
    537,
    538,
    539,
    540,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  542: [
    536,
    537,
    538,
    539,
    540,
    541,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  543: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  544: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  545: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  546: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  547: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  548: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    549,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  549: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    550,
    551,
    552,
    553,
    554,
    555,
  ],
  550: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    551,
    552,
    553,
    554,
    555,
  ],
  551: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    552,
    553,
    554,
    555,
  ],
  552: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    553,
    554,
    555,
  ],
  553: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    554,
    555,
  ],
  554: [
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    555,
  ],
  555: [
    26,
    47,
    54,
    111,
    165,
    196,
    201,
    273,
    352,
    370,
    385,
    413,
    423,
    432,
    441,
    477,
    497,
    515,
    535,
    536,
    537,
    538,
    539,
    540,
    541,
    542,
    543,
    544,
    545,
    546,
    547,
    548,
    549,
    550,
    551,
    552,
    553,
    554,
  ],
  556: [
    428,
    450,
    476,
    494,
    557,
    558,
    559,
    560,
    561,
    562,
    563,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  557: [
    428,
    450,
    476,
    494,
    556,
    558,
    559,
    560,
    561,
    562,
    563,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  558: [
    428,
    450,
    476,
    494,
    556,
    557,
    559,
    560,
    561,
    562,
    563,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  559: [
    428,
    450,
    476,
    494,
    556,
    557,
    558,
    560,
    561,
    562,
    563,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  560: [
    428,
    450,
    476,
    494,
    556,
    557,
    558,
    559,
    561,
    562,
    563,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  561: [
    428,
    450,
    476,
    494,
    556,
    557,
    558,
    559,
    560,
    562,
    563,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  562: [
    428,
    450,
    476,
    494,
    556,
    557,
    558,
    559,
    560,
    561,
    563,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  563: [
    428,
    450,
    476,
    494,
    556,
    557,
    558,
    559,
    560,
    561,
    562,
    564,
    565,
    566,
    567,
    568,
    569,
  ],
  564: [
    428,
    450,
    476,
    494,
    556,
    557,
    558,
    559,
    560,
    561,
    562,
    563,
    565,
    566,
    567,
    568,
    569,
  ],
  565: [
    428,
    450,
    476,
    494,
    556,
    557,
    558,
    559,
    560,
    561,
    562,
    563,
    564,
    566,
    567,
    568,
    569,
  ],
  566: [
    428,
    450,
    476,
    494,
    556,
    557,
    558,
    559,
    560,
    561,
    562,
    563,
    564,
    565,
    567,
    568,
    569,
  ],
  567: [
    428,
    450,
    476,
    494,
    556,
    557,
    558,
    559,
    560,
    561,
    562,
    563,
    564,
    565,
    566,
    568,
    569,
  ],
  568: [
    428,
    450,
    476,
    494,
    556,
    557,
    558,
    559,
    560,
    561,
    562,
    563,
    564,
    565,
    566,
    567,
    569,
  ],
  569: [
    428,
    450,
    476,
    494,
    556,
    557,
    558,
    559,
    560,
    561,
    562,
    563,
    564,
    565,
    566,
    567,
    568,
  ],
  570: [
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  571: [
    570,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  572: [
    570,
    571,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  573: [
    570,
    571,
    572,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  574: [
    570,
    571,
    572,
    573,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  575: [
    570,
    571,
    572,
    573,
    574,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  576: [
    570,
    571,
    572,
    573,
    574,
    575,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  577: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  578: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  579: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  580: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  581: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  582: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    583,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  583: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    584,
    585,
    586,
    587,
    588,
    589,
  ],
  584: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    585,
    586,
    587,
    588,
    589,
  ],
  585: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    586,
    587,
    588,
    589,
  ],
  586: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    587,
    588,
    589,
  ],
  587: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    588,
    589,
  ],
  588: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    589,
  ],
  589: [
    570,
    571,
    572,
    573,
    574,
    575,
    576,
    577,
    578,
    579,
    580,
    581,
    582,
    583,
    584,
    585,
    586,
    587,
    588,
  ],
};

export var players = [
  "Sonja Christopher",
  "B.B. Andersen",
  "Stacey Stillman",
  "Ramona Gray",
  "Dirk Been",
  "Joel Klug",
  "Gretchen Cordy",
  "Greg Buis",
  "Jenna Lewis",
  "Gervase Peterson",
  "Colleen Haskell",
  "Sean Kenniff",
  "Susan Hawk",
  "Rudy Boesch",
  "Kelly Wiglesworth",
  "Richard Hatch",
  "Debb Eaton",
  "Kel Gleason",
  "Maralyn Hershey",
  "Mitchell Olson",
  "Kimmi Kappenberg",
  "Michael Skupin",
  "Jeff Varner",
  "Alicia Calaway",
  "Jerri Manthey",
  "Nick Brown",
  "Amber Mariano",
  "Rodger Bingham",
  "Elisabeth Filarski",
  "Keith Famie",
  "Colby Donaldson",
  "Tina Wesson",
  "Diane Ogden",
  "Jessie Camacho",
  "Carl Bilancione",
  "Linda Spencer",
  "Silas Gaither",
  "Lindsey Richter",
  "Clarence Black",
  "Kelly Goldsmith",
  "Brandon Quinton",
  "Frank Garrison",
  "Kim Powers",
  "Teresa Cooper",
  "Tom Buchanan",
  "Lex van den Berghe",
  "Kim Johnson",
  "Ethan Zohn",
  "Peter Harkey",
  "Patricia Jackson",
  "Hunter Ellis",
  "Sarah Jones",
  "Gabriel Cade",
  "Gina Crews",
  "Rob Mariano",
  "John Carroll",
  "Zoe Zanidakis",
  "Tammy Leitner",
  "Robert DeCanio",
  "Sean Rector",
  "Paschal English",
  "Kathy Vavrick-O'Brien",
  "Neleh Dennis",
  "Vecepia Towery",
  "John Raymond",
  "Tanya Vance",
  "Jed Hildebrand",
  "Ghandia Johnson",
  "Stephanie Dill",
  "Robb Zbacnik",
  "Shii Ann Huang",
  "Erin Collins",
  "Ken Stafford",
  "Penny Ramsey",
  "Jake Billingsley",
  "Ted Rogers, Jr.",
  "Helen Glover",
  "Jan Gentry",
  "Clay Jordan",
  "Brian Heidik",
  "Ryan Aiken",
  "Janet Koth",
  "Daniel Lue",
  "JoAnna Ward",
  "Jeanne Hebert",
  "Shawna Mitchell",
  "Roger Sexton",
  "Dave Johnson",
  "Deena Bennett",
  "Alex Bell",
  "Christy Smith",
  "Heidi Strobel",
  "Butch Lockley",
  "Rob Cesternino",
  "Matthew von Ertfelda",
  "Jenna Morasca",
  "Nicole Delma",
  "Ryan Shoulders",
  "Michelle Tesauro",
  "Trish Dunn",
  "Shawn Cohen",
  "Osten Taylor",
  "Andrew Savage",
  "Ryan Opray",
  "Rupert Boneham",
  "Tijuana Bradley",
  "Christa Hastie",
  "Burton Roberts",
  "Darrah Johnson",
  "Jon Dalton",
  "Lillian Morris",
  "Sandra Diaz-Twine",
  "Brook Geraghty",
  "Dolly Neely",
  "John Palyok",
  "Mia Galeotalanza",
  "Brady Finta",
  "Travis Sampson",
  "Lisa Keiffer",
  "John Kenney",
  "Rory Freeman",
  "Lea Masters",
  "Chad Crittenden",
  "Leann Slaby",
  "Ami Cusack",
  "Julie Berry",
  "Eliza Orlins",
  "Scout Cloud Lee",
  "Twila Tanner",
  "Chris Daugherty",
  "Jonathan Libby",
  "Wanda Shirk",
  "Jolanda Jones",
  "Ashlee Ashby",
  "Jeff Wilson",
  "Kim Mullen",
  "Willard Smith",
  "Angie Jakusz",
  "James Miller",
  "Ibrehem Rahman",
  "Bobby Jon Drinkard",
  "Coby Archa",
  "Janu Tornell",
  "Stephenie LaGrossa",
  "Gregg Carey",
  "Caryn Groedel",
  "Jenn Lyon",
  "Ian Rosenberger",
  "Katie Gallagher",
  "Tom Westman",
  "Jim Lynch",
  "Morgan McDevitt",
  "Brianna Varela",
  "Brooke Struck",
  "Blake Towsley",
  "Margaret Bobonich",
  "Brian Corridan",
  "Amy O'Hara",
  "Brandon Bellinger",
  "Jamie Newton",
  "Gary Hogeboom",
  "Judd Sergeant",
  "Cindy Hall",
  "Lydia Morales",
  "Rafe Judkins",
  "Danni Boatwright",
  "Tina Scheer",
  "Melinda Hyder",
  "Misty Giles",
  "Ruth Marie Milliman",
  "Bobby Mason",
  "Dan Barry",
  "Nick Stanbury",
  "Austin Carty",
  "Sally Schumann",
  "Bruce Kanegai",
  "Courtney Marit",
  "Shane Powers",
  "Cirie Fields",
  "Terry Deitz",
  "Danielle DiLorenzo",
  "Aras Baskauskas",
  "Sekou Bunch",
  "Billy Garcia",
  "Cecilia Mansilla",
  "J.P. Calderon",
  "Stephannie Favor",
  "Cao Boi Bui",
  "Cristina Coria",
  "Jessica Smith",
  "Brad Virata",
  "Rebecca Borman",
  "Jenny Guzon-Bae",
  "Nate Gonzalez",
  "Candice Cody",
  "Jonathan Penner",
  "Parvati Shallow",
  "Adam Gentry",
  "Sundra Oakley",
  "Becky Lee",
  "Ozzy Lusth",
  "Yul Kwon",
  "Jessica deBen",
  "Erica Durousseau",
  "Sylvia Kwan",
  "Gary Stritesky",
  "Liliana Gomez",
  "Rita Verreos",
  "Anthony Robinson",
  "Rocky Reid",
  "Lisi Linares",
  "Michelle Yi",
  "Edgardo Rivera",
  "Mookie Lee",
  "Alex Angarita",
  "Stacy Kimball",
  "Boo Bernis",
  "Yau-Man Chan",
  "Cassandra Franklin",
  "Dreamz Herd",
  "Earl Cole",
  "Chicken Morris",
  "Ashley Massaro",
  "Leslie Nease",
  "Dave Cruser",
  "Aaron Reisberger",
  "Sherea Lloyd",
  "Jaime Dugan",
  "Jean-Robert Bellande",
  "Frosti Zernow",
  "James Clement",
  "Erik Huffman",
  "Peih-Gee Law",
  "Denise Martin",
  "Amanda Kimmel",
  "Courtney Yates",
  "Todd Herzog",
  "Mary Sartain",
  "Mikey Bortone",
  "Joel Anderson",
  "Chet Welch",
  "Kathy Sleckman",
  "Tracy Hughes-Wolf",
  "Jason Siska",
  "Alexis Jones",
  "Erik Reichenbach",
  "Natalie Bolton",
  "Michelle Chase",
  "Gillian Larson",
  "Paloma Soto-Castillo",
  "Jacquie Berg",
  "GC Brown",
  "Kelly Czarnecki",
  "Ace Gordon",
  "Dan Kay",
  "Marcus Lehman",
  "Charlie Herschel",
  "Randy Bailey",
  "Corinne Kaplan",
  "Crystal Cox",
  "Ken Hoang",
  "Matty Whitmore",
  "Sugar Kiper",
  "Susie Smith",
  "Bob Crowley",
  "Carolina Eastwood",
  "Candace Smith",
  "Jerry Sims",
  "Sandy Burgin",
  "Spencer Duhm",
  "Sydney Wheeler",
  "Joe Dowdle",
  "Brendan Synnott",
  "Tyson Apostol",
  "Sierra Reed",
  "Debbie Beebe",
  "Coach Wade",
  "Taj Johnson-George",
  "Erinn Lobdell",
  "Stephen Fishbach",
  "J.T. Thomas",
  "Marisa Calihan",
  "Mike Borassi",
  "Betsy Bolan",
  "Ben Browning",
  "Yasmin Giles",
  "Ashley Trainer",
  "Russell Swan",
  "Liz Kim",
  "Erik Cardona",
  "Kelly Sharbaugh",
  "Laura Morett",
  "John Fincher",
  "Dave Ball",
  "Monica Padilla",
  "Shambo Waters",
  "Jaison Robinson",
  "Brett Clouser",
  "Mick Trimming",
  "Russell Hantz",
  "Natalie White",
  "Wendy DeSmidt-Kohlhoff",
  "Shannon Elkins",
  "Jimmy Johnson",
  "Jimmy Tarantino",
  "Tyrone Davis",
  "Kelly Bruno",
  "Yve Rojas",
  "Jill Behm",
  "Alina Wilson",
  "Marty Piombo",
  "Brenda Lowe",
  "NaOnka Mixon",
  "Kelly Shinn",
  "Benry Henry",
  "Jane Bright",
  "Dan Lembo",
  "Holly Hoffman",
  "Sash Lenahan",
  "Chase Rice",
  "Fabio Birza",
  "Francesca Hogi",
  "Kristina Kell",
  "Krista Klumpp",
  "Stephanie Valencia",
  "Sarita White",
  "David Murphy",
  "Julie Wolfe",
  "Steve Wright",
  "Ralph Kiser",
  "Grant Mattos",
  "Matt Elrod",
  "Mike Chiesl",
  "Andrea Boehlke",
  "Ashley Underwood",
  "Natalie Tenerelli",
  "Phillip Sheppard",
  "Semhar Tadesse",
  "Mark Caruso",
  "Stacey Powell",
  "Elyse Umemoto",
  "Mikayla Wingle",
  "Christine Shields Markoski",
  "Jim Rice",
  "Keith Tollefson",
  "Dawn Meehan",
  "Whitney Duncan",
  "John Cochran",
  "Edna Ma",
  "Brandon Hantz",
  "Rick Nelson",
  "Albert Destrade",
  "Sophie Clarke",
  "Kourtney Moon",
  "Nina Acosta",
  "Matt Quinlan",
  "Bill Posley",
  "Monica Culpepper",
  "Colton Cumbie",
  "Jonas Otsuji",
  "Michael Jefferson",
  "Jay Byars",
  "Leif Manson",
  "Troyzan Robertson",
  "Kat Edorsson",
  "Tarzan Smith",
  "Alicia Rosa",
  "Christina Cha",
  "Chelsea Meissner",
  "Sabrina Thompson",
  "Kim Spradlin-Wolfe",
  "Zane Knight",
  "Roxy Morris",
  "Angie Layton",
  "Dana Lambert",
  "Sarah Dawson",
  "Katie Hanson",
  "RC Saint-Amour",
  "Jeff Kent",
  "Artis Silvester",
  "Pete Yurkowski",
  "Carter Williams",
  "Abi-Maria Gomes",
  "Malcolm Freberg",
  "Lisa Whelchel",
  "Denise Stapley",
  "Allie Pohevitz",
  "Hope Driskill",
  "Shamar Thomas",
  "Laura Alexander",
  "Matt Bischoff",
  "Julia Landauer",
  "Michael Snow",
  "Reynold Toepfer",
  "Eddie Fox",
  "Sherri Biethman",
  "Rachel Foulger",
  "Marissa Peterson",
  "Brad Culpepper",
  "John Cody",
  "Laura Boneham",
  "Vytas Baskauskas",
  "Caleb Bankston",
  "Katie Collins",
  "Hayden Moss",
  "Ciera Eastin",
  "David Samson",
  "Garrett Adelstein",
  "Brice Johnston",
  "J'Tia Taylor",
  "Cliff Robinson",
  "Lindsey Ogle",
  "Alexis Maxwell",
  "Sarah Lacina",
  "Morgan McLeod",
  "LJ McKanas",
  "Jeremiah Wood",
  "Jefra Bland",
  "Tasha Fox",
  "Trish Hegarty",
  "Spencer Bledsoe",
  "Kass McQuillen",
  "Woo Hwang",
  "Tony Vlachos",
  "Nadiya Anderson",
  "Val Collins",
  "John Rocker",
  "Drew Christy",
  "Kelley Wentworth",
  "Dale Wentworth",
  "Julie McGee",
  "Josh Canfield",
  "Jeremy Collins",
  "Wes Nale",
  "Reed Kelly",
  "Alec Christy",
  "Jon Misch",
  "Baylor Wilson",
  "Keith Nale",
  "Missy Payne",
  "Jaclyn Schultz",
  "Natalie Anderson",
  "So Kim",
  "Vince Sly",
  "Nina Poersch",
  "Lindsey Cascaddan",
  "Max Dawson",
  "Joaquin Souberbielle",
  "Kelly Remington",
  "Hali Ford",
  "Joe Anglim",
  "Jenn Brown",
  "Shirin Oskooi",
  "Tyler Fredrickson",
  "Dan Foley",
  "Sierra Dawn Thomas",
  "Rodney Lavoie Jr.",
  "Carolyn Rivera",
  "Will Sims II",
  "Mike Holloway",
  "Darnell Hamilton",
  "Jennifer Lanzetti",
  "Liz Markham",
  "Caleb Reynolds",
  "Alecia Holden",
  "Anna Khait",
  "Peter Baggenstos",
  "Neal Gottlieb",
  "Nick Maiorano",
  "Debbie Wanner",
  "Scot Pollard",
  "Julia Sokolowski",
  "Kyle Jason",
  "Joe del Campo",
  "Cydney Gillon",
  "Tai Trang",
  "Aubry Bracco",
  "Michele Fitzgerald",
  "Rachel Ako",
  "Mari Takahashi",
  "Paul Wachter",
  "Lucy Huang",
  "CeCe Taylor",
  "Figgy Figueroa",
  "Michaela Bradshaw",
  "Michelle Schubert",
  "Taylor Stocker",
  "Chris Hammons",
  "Jessica Lewis",
  "Zeke Smith",
  "Will Wahl",
  "Sunday Burquest",
  "Jay Starrett",
  "Bret LaBelle",
  "David Wright",
  "Hannah Shapiro",
  "Ken McNickle",
  "Adam Klein",
  "Katrina Radke",
  "Simone Nguyen",
  "Patrick Bolton",
  "Alan Ball",
  "Roark Luskin",
  "Ali Elliott",
  "Jessica Johnston",
  "Desi Williams",
  "Cole Medders",
  "JP Hilsabeck",
  "Joe Mena",
  "Lauren Rimmer",
  "Ashley Nolan",
  "Mike Zahalsky",
  "Devon Pinto",
  "Ryan Ulrich",
  "Chrissy Hofbeck",
  "Ben Driebergen",
  "Stephanie Gonzalez",
  "Jacob Derwin",
  "Morgan Ricke",
  "Brendan Shapiro",
  "Stephanie Johnson",
  "James Lim",
  "Bradley Kleihege",
  "Chris Noble",
  "Libby Vincek",
  "Desiree Afuye",
  "Jenna Bowman",
  "Michael Yerger",
  "Chelsea Townsend",
  "Kellyn Bechtold",
  "Sebastian Noel",
  "Donathan Hurley",
  "Angela Perkins",
  "Laurel Johnson",
  "Domenick Abbate",
  "Wendell Holland",
  "Pat Cusack",
  "Jessica Peet",
  "Jeremy Crawford",
  "Bi Nguyen",
  "Natalia Azoqa",
  "Natalie Cole",
  "Lyrsa Torres",
  "Elizabeth Olson",
  "John Hennigan",
  "Dan Rengering",
  "Alec Merlino",
  "Carl Boudreaux",
  "Gabby Pascuzzi",
  "Christian Hubicki",
  "Davie Rickenbacker",
  "Alison Raybould",
  "Kara Kay",
  "Angelina Keeley",
  "Mike White",
  "Nick Wilson",
  "Reem Daly",
  "Keith Sowell",
  "Wendy Diaz",
  "Eric Hafemann",
  "Julia Carter",
  "Wardog DaSilva",
  "Ron Clark",
  "Aurora McCreary",
  "Victoria Baamonde",
  "Lauren O'Connell",
  "Rick Devens",
  "Julie Rosenberg",
  "Gavin Whitson",
  "Chris Underwood",
  "Ronnie Bardah",
  "Molly Byman",
  "Vince Moua",
  "Chelsea Walker",
  "Tom Laidlaw",
  "Jason Linden",
  "Jack Nichting",
  "Kellee Kim",
  "Jamal Shipman",
  "Aaron Meredith",
  "Missy Byrd",
  "Elizabeth Beisel",
  "Karishma Patel",
  "Elaine Stott",
  "Dan Spilo",
  "Janet Carbin",
  "Lauren Beck",
  "Noura Salman",
  "Dean Kowalski",
  "Tommy Sheehan",
];

export var seasons = [
  [1],
  [1],
  [1],
  [1],
  [1],
  [1],
  [1],
  [1],
  [1, 8],
  [1, 27],
  [1],
  [1],
  [1, 8],
  [1, 8],
  [1, 31],
  [1, 8],
  [2],
  [2],
  [2],
  [2],
  [2, 31],
  [2, 25],
  [2, 31, 34],
  [2, 8],
  [2, 8, 20],
  [2],
  [2, 8, 40],
  [2],
  [2],
  [2],
  [2, 8, 20],
  [2, 8, 27],
  [3],
  [3],
  [3],
  [3],
  [3],
  [3],
  [3],
  [3],
  [3],
  [3],
  [3],
  [3],
  [3, 8],
  [3, 8],
  [3],
  [3, 8, 40],
  [4],
  [4],
  [4],
  [4],
  [4],
  [4],
  [4, 8, 20, 22, 40],
  [4],
  [4],
  [4],
  [4],
  [4],
  [4],
  [4, 8],
  [4],
  [4],
  [5],
  [5],
  [5],
  [5],
  [5],
  [5],
  [5, 8],
  [5],
  [5],
  [5],
  [5],
  [5],
  [5],
  [5],
  [5],
  [5],
  [6],
  [6],
  [6],
  [6],
  [6],
  [6],
  [6],
  [6],
  [6],
  [6],
  [6],
  [6],
  [6],
  [6, 8],
  [6],
  [6, 8],
  [7],
  [7],
  [7],
  [7],
  [7],
  [7],
  [7, 31],
  [7],
  [7, 8, 20, 27],
  [7],
  [7],
  [7],
  [7],
  [7, 16],
  [7],
  [7, 20, 34, 40],
  [9],
  [9],
  [9],
  [9],
  [9],
  [9],
  [9],
  [9],
  [9],
  [9],
  [9],
  [9],
  [9, 16],
  [9],
  [9, 16],
  [9],
  [9],
  [9],
  [10],
  [10],
  [10],
  [10],
  [10],
  [10],
  [10],
  [10],
  [10],
  [10],
  [10, 11],
  [10],
  [10],
  [10, 11, 20],
  [10],
  [10],
  [10],
  [10],
  [10],
  [10, 20],
  [11],
  [11],
  [11],
  [11],
  [11],
  [11],
  [11],
  [11],
  [11],
  [11],
  [11],
  [11],
  [11],
  [11],
  [11],
  [11, 40],
  [12],
  [12],
  [12],
  [12],
  [12],
  [12],
  [12],
  [12],
  [12],
  [12],
  [12],
  [12],
  [12, 16, 20, 34],
  [12, 31],
  [12, 20],
  [12, 27],
  [13],
  [13],
  [13],
  [13],
  [13],
  [13],
  [13],
  [13],
  [13],
  [13],
  [13],
  [13],
  [13, 20, 27],
  [13, 16, 25],
  [13, 16, 20, 40],
  [13],
  [13],
  [13],
  [13, 16, 23, 34],
  [13, 40],
  [14],
  [14],
  [14],
  [14],
  [14],
  [14],
  [14],
  [14],
  [14],
  [14],
  [14],
  [14],
  [14],
  [14],
  [14],
  [14, 16],
  [14],
  [14],
  [14],
  [15],
  [15],
  [15],
  [15],
  [15],
  [15],
  [15],
  [15],
  [15],
  [15, 16, 20],
  [15],
  [15, 31],
  [15],
  [15, 16, 20],
  [15, 20],
  [15],
  [16],
  [16],
  [16],
  [16],
  [16],
  [16],
  [16],
  [16],
  [16, 26],
  [16],
  [17],
  [17],
  [17],
  [17],
  [17],
  [17],
  [17],
  [17],
  [17],
  [17],
  [17, 20],
  [17, 26],
  [17],
  [17],
  [17],
  [17, 20],
  [17],
  [17],
  [18],
  [18],
  [18],
  [18],
  [18],
  [18],
  [18],
  [18],
  [18, 20, 27, 40],
  [18],
  [18],
  [18, 20, 23],
  [18],
  [18],
  [18, 31],
  [18, 20, 34],
  [19],
  [19],
  [19],
  [19],
  [19],
  [19],
  [19, 25],
  [19],
  [19],
  [19],
  [19, 27],
  [19],
  [19],
  [19, 31],
  [19],
  [19],
  [19],
  [19],
  [19, 20, 22],
  [19],
  [21],
  [21],
  [21],
  [21],
  [21],
  [21],
  [21],
  [21],
  [21],
  [21],
  [21, 26],
  [21],
  [21],
  [21],
  [21],
  [21],
  [21],
  [21],
  [21],
  [21],
  [22, 26],
  [22],
  [22],
  [22],
  [22],
  [22],
  [22],
  [22],
  [22],
  [22],
  [22],
  [22],
  [22, 26, 34],
  [22],
  [22],
  [22, 26],
  [23],
  [23],
  [23],
  [23],
  [23],
  [23],
  [23],
  [23],
  [23, 26],
  [23],
  [23, 26],
  [23],
  [23, 26],
  [23],
  [23],
  [23, 40],
  [24],
  [24],
  [24],
  [24],
  [24, 27],
  [24, 27],
  [24],
  [24],
  [24],
  [24],
  [24, 34],
  [24, 27],
  [24],
  [24],
  [24],
  [24],
  [24],
  [24, 40],
  [25],
  [25],
  [25],
  [25],
  [25],
  [25],
  [25],
  [25],
  [25],
  [25],
  [25],
  [25, 31],
  [25, 26, 34],
  [25],
  [25, 40],
  [26],
  [26],
  [26],
  [26],
  [26],
  [26],
  [26],
  [26],
  [26],
  [26],
  [27],
  [27],
  [27, 34],
  [27],
  [27],
  [27, 31],
  [27],
  [27],
  [27],
  [27, 31, 34],
  [28],
  [28],
  [28],
  [28],
  [28],
  [28],
  [28],
  [28, 34, 40],
  [28],
  [28],
  [28],
  [28],
  [28, 31],
  [28],
  [28, 31],
  [28, 31],
  [28, 31],
  [28, 34, 40],
  [29],
  [29],
  [29],
  [29],
  [29, 31, 38],
  [29],
  [29],
  [29],
  [29, 31, 40],
  [29],
  [29],
  [29],
  [29],
  [29],
  [29, 31],
  [29],
  [29],
  [29, 40],
  [30],
  [30],
  [30],
  [30],
  [30],
  [30],
  [30],
  [30, 34],
  [30, 31, 38],
  [30],
  [30, 31],
  [30],
  [30],
  [30, 34],
  [30],
  [30],
  [30],
  [30],
  [32],
  [32],
  [32],
  [32, 34],
  [32],
  [32],
  [32],
  [32],
  [32],
  [32, 34],
  [32],
  [32],
  [32],
  [32],
  [32],
  [32, 34],
  [32, 34, 38],
  [32, 40],
  [33],
  [33],
  [33],
  [33],
  [33],
  [33],
  [33, 34],
  [33],
  [33],
  [33],
  [33],
  [33, 34],
  [33],
  [33],
  [33],
  [33],
  [33, 38],
  [33],
  [33],
  [33, 40],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35],
  [35, 40],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36],
  [36, 40],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37],
  [37, 40],
  [38],
  [38],
  [38],
  [38],
  [38],
  [38],
  [38],
  [38],
  [38],
  [38],
  [38],
  [38],
  [38],
  [38],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
  [39],
];

export var seasonNames = {
  1: "Survivor: Borneo",
  2: "Survivor: The Australian Outback",
  3: "Survivor: Africa",
  4: "Survivor: Marquesas",
  5: "Survivor: Thailand",
  6: "Survivor: The Amazon",
  7: "Survivor: Pearl Islands",
  8: "Survivor: All-Stars",
  9: "Survivor: Vanuatu",
  10: "Survivor: Palau",
  11: "Survivor: Guatemala",
  12: "Survivor: Panama",
  13: "Survivor: Cook Islands",
  14: "Survivor: Fiji",
  15: "Survivor: China",
  16: "Survivor: Micronesia",
  17: "Survivor: Gabon",
  18: "Survivor: Tocantins",
  19: "Survivor: Samoa",
  20: "Survivor: Heroes vs. Villains",
  21: "Survivor: Nicaragua",
  22: "Survivor: Redemption Island",
  23: "Survivor: South Pacific",
  24: "Survivor: One World",
  25: "Survivor: Philippines",
  26: "Survivor: Caramoan",
  27: "Survivor: Blood vs. Water",
  28: "Survivor: Cagayan",
  29: "Survivor: San Juan del Sur",
  30: "Survivor: Worlds Apart",
  31: "Survivor: Cambodia",
  32: "Survivor: Kaôh Rōng",
  33: "Survivor: Millennials vs. Gen X",
  34: "Survivor: Game Changers",
  35: "Survivor: Heroes vs. Healers vs. Hustlers",
  36: "Survivor: Ghost Island",
  37: "Survivor: David vs. Goliath",
  38: "Survivor: Edge of Extinction",
  39: "Survivor: Island of the Idols",
  40: "Survivor: Winners at War",
};

export var seasonNamesShort = {
  1: "Borneo",
  2: "The Australian Outback",
  3: "Africa",
  4: "Marquesas",
  5: "Thailand",
  6: "The Amazon",
  7: "Pearl Islands",
  8: "All-Stars",
  9: "Vanuatu",
  10: "Palau",
  11: "Guatemala",
  12: "Panama",
  13: "Cook Islands",
  14: "Fiji",
  15: "China",
  16: "Micronesia",
  17: "Gabon",
  18: "Tocantins",
  19: "Samoa",
  20: "Heroes vs. Villains",
  21: "Nicaragua",
  22: "Redemption Island",
  23: "South Pacific",
  24: "One World",
  25: "Philippines",
  26: "Caramoan",
  27: "Blood vs. Water",
  28: "Cagayan",
  29: "San Juan del Sur",
  30: "Worlds Apart",
  31: "Cambodia",
  32: "Kaôh Rōng",
  33: "Millennials vs. Gen X",
  34: "Game Changers",
  35: "Heroes vs. Healers vs. Hustlers",
  36: "Ghost Island",
  37: "David vs. Goliath",
  38: "Edge of Extinction",
  39: "Island of the Idols",
  40: "Winners at War",
};